import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import { Divider } from '@mui/material';
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import NoData from '../NoData';
export default class CarbonFootprintOffsetList extends Component {
    render() {
        return (
            <Card className="popup" id="child_CarbonFootprintOffsetList">
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                <Box className="popupHeader">
                <Typography variant="h4" fontWeight="800" align="center" gutterBottom>
                        OFFSETS IN THE LAST 12 MONTHS
                    </Typography>

                    <Divider sx={{ marginBottom: "1rem" }} variant="light" />
                    </Box>
                    <Box className="popupBody">
                <CardContent textAlign="center">

                    {this.props.offsetList ?
                        <Typography variant="h4">Offset List</Typography> :
                        <NoData text="You have no offsets in the last 12 months" />
                    }

                </CardContent>
                </Box>
            </Card>
        )
    }
}
